module.exports = __webpack_public_path__ + "static/media/Flutter Magazine -  Al Fresco Gathering.bf1bfe0a.pdf";